import PortalAdmin from "../templates/PortalAdmin";

export default [
  {
    path: "/mmi/admin-portal",
    Component: PortalAdmin,
  },
];
